import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { ClientData } from '../../providers/client';
import { LandingPage } from '../landing/landing';

@Component({
  selector: 'page-client',
  templateUrl: 'client.html'
})
export class ClientPage {

  codeClient: any;
  toast: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public clientProvider: ClientData) {}

  validate() {
    let code: string;

    if (this.toast) {
      this.toast.dismiss();
    }

    if (!this.codeClient) {
      this.toast = this.toastCtrl.create({
        message: 'Debe ingresar un código',
        duration: 3000,
      });

      this.toast.present();
    } else {
      code = this.codeClient;
      this.codeClient = null;

      let loading = this.loadingCtrl.create({
        content: 'Validando..',
        dismissOnPageChange: true
      });

      loading.present();

      this.clientProvider.searchClient(code, 'secretCode')
      .then((result: any) => {
        this.navCtrl.setRoot(LandingPage, {url: result.url});
      })
      .catch((error) => {
        loading.dismiss();

        this.toast = this.toastCtrl.create({
          message: 'El código ingresado no ha sido encontrado',
          duration: 3000,
        });

        this.toast.present();
      });
    }
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/client/client.ts